import React from "react";
import "./_color-item.scss";

export default function ColorItem({value, className}) {
    return (
        <div className="color-item">
            <div className={className} style={{background: value || "#FFF"}}/>
        </div>
    );
}